export const GROSS_VOLUME = '65f8615c7f588e000ba3c2c4';
export const NET_VOLUME = '65b3ab2c788320000b9e06b0';
export const MRR = '65b3a971788320000b9e0448';
export const CUSTOMERS = '65b38209e5c942000ba151c7';
export const AVERAGE_SPEND_PER_CUSTOMER = '65b37e0f4a0859000bd04cd1';
export const AMOUNT_ON_RAMPED = '65f8d676c038ce000b20d267';
export const AMOUNT_OFF_RAMPED = '65f0af964fa841000b0599a4';
export const SUCCESSFUL_PAYMENTS = '65b3aa52788320000b9e055d';
export const FAILED_PAYMENTS = '65b3aa88788320000b9e0571';
